import React from 'react';
import './Notification.scss';
import checkimage from "../../../assets/check-circle.svg"
import exclamationImage from "../../../assets/exclamation-circle.svg"

// Define the type for props
interface NotificationProps {
  message: string;
  backgroundColor: string;
  textColor: string;
  isError:boolean;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({ message, backgroundColor, textColor, isError, onClose }) => {
  const notificationStyle = {
    backgroundColor,
    color: textColor,
  };



  // return (
  //   <div className="notification" style={notificationStyle}>
  //     <div className="notification__message flash-message">
  //       <span role="img" aria-label="check" className="notification__icon">
  //         <img src={message=="Notification Sent"?checkimage:exclamationImage} />
  //       </span>
  //       {message}
  //     </div>
  //     <button className="notification__close" onClick={onClose}>
  //       ❌
  //     </button>
  //   </div>
  // );

  return (
    <div className="notification" style={notificationStyle}>
      <div key={message} className="notification__message flash-message">
        <span role="img" aria-label="check" className="notification__icon">
          {/* <img src={isError === false ? checkimage : exclamationImage} alt="check" /> */}
          {isError === false?
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tick-mark bi bi-check-circle-fill" viewBox="0 0 17 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
            :  
            <img src={exclamationImage} alt="check" />
        }
        
        </span>
        {message}
      </div>
      <button className="notification__close" onClick={onClose}>
        ❌
      </button>
    </div>
  );



};

export default Notification;